import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["className", "id", "size", "mode", "items", "renderItem", "emptyState", "searchBy", "hasPagination", "total", "filteredTotal", "action", "isManualPagination", "pageIndex", "pageSizeOptions", "defaultPageSize", "isLoading", "isSearchable", "isEmpty", "hasViewMode", "defaultMode", "hasTotal", "rowText", "showPerPageText", "pageText", "rowsText", "searchText", "filteredText", "filters", "gridColumns", "delay", "onSearchChange", "onFilterChange", "filter", "search", "loadingText", "clearFiltersText", "ofText", "noResultsText"],
    _excluded2 = ["className", "title", "metadata", "media", "children", "actions", "onClick"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useState, useEffect, useMemo, useReducer } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './List.styles';
import Card from '../Card';
import Paragraph from '../Paragraph';
import SegmentedControl from '../SegmentedControl';
import EmptyState from '../EmptyState';
import Divider from '../Divider';
import Icon from '../Icon';
import Dropdown from '../Dropdown';
import Stack from '../Stack';
import IconButton from '../IconButton';
import Button from '../Button';
import Link from '../Link';
import Loading from '../Loading';
import usePagination from '../../hooks/usePagination';
import { useDebounce } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function filterPlainArray(array, filters) {
  var filterKeys = Object.keys(filters);
  return array.filter(function (item) {
    return filterKeys.every(function (key) {
      if (!filters[key].length) return true;
      return filters[key].find(function (filter) {
        return item[key].toString().toLowerCase().includes(filters[key].toString().toLowerCase());
      });
    });
  });
}

function reducer(state, action) {
  switch (action.type) {
    case 'search':
      if (action.payload.value) {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.key, [action.payload.value]));
      } else {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, action.payload.key, []));
      }

    case 'sort':
      break;

    case 'clear':
      return {};

    case 'clear_search':
      delete state[action.payload.key];
      return state;

    default:
      throw new Error();
  }
}

var OptionsList = function OptionsList(_ref) {
  var options = _ref.options;
  return _jsx(_Fragment, {
    children: options.map(function (option, index) {
      return 'options' in option ? _jsx(Dropdown.OptionGroup, {
        label: option.label,
        children: _jsx(OptionsList, {
          options: option.options
        })
      }, index) : _jsx(Dropdown.Option, {
        value: option.value,
        children: option.label
      }, option.value);
    })
  });
};

var List = forwardRef(function (_ref2, ref) {
  var _cx;

  var customClassName = _ref2.className,
      id = _ref2.id,
      size = _ref2.size,
      mode = _ref2.mode,
      _ref2$items = _ref2.items,
      items = _ref2$items === void 0 ? [] : _ref2$items,
      renderItem = _ref2.renderItem,
      emptyState = _ref2.emptyState,
      _ref2$searchBy = _ref2.searchBy,
      searchBy = _ref2$searchBy === void 0 ? '' : _ref2$searchBy,
      _ref2$hasPagination = _ref2.hasPagination,
      hasPagination = _ref2$hasPagination === void 0 ? false : _ref2$hasPagination,
      _ref2$total = _ref2.total,
      controlledTotal = _ref2$total === void 0 ? 0 : _ref2$total,
      _ref2$filteredTotal = _ref2.filteredTotal,
      controlledFilteredTotal = _ref2$filteredTotal === void 0 ? 0 : _ref2$filteredTotal,
      action = _ref2.action,
      _ref2$isManualPaginat = _ref2.isManualPagination,
      isManualPagination = _ref2$isManualPaginat === void 0 ? false : _ref2$isManualPaginat,
      _ref2$pageIndex = _ref2.pageIndex,
      controlledPageIndex = _ref2$pageIndex === void 0 ? 1 : _ref2$pageIndex,
      _ref2$pageSizeOptions = _ref2.pageSizeOptions,
      pageSizeOptions = _ref2$pageSizeOptions === void 0 ? [10, 20, 30, 50, 100] : _ref2$pageSizeOptions,
      _ref2$defaultPageSize = _ref2.defaultPageSize,
      defaultPageSize = _ref2$defaultPageSize === void 0 ? 10 : _ref2$defaultPageSize,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      _ref2$isSearchable = _ref2.isSearchable,
      isSearchable = _ref2$isSearchable === void 0 ? false : _ref2$isSearchable,
      _ref2$isEmpty = _ref2.isEmpty,
      isEmpty = _ref2$isEmpty === void 0 ? false : _ref2$isEmpty,
      _ref2$hasViewMode = _ref2.hasViewMode,
      hasViewMode = _ref2$hasViewMode === void 0 ? false : _ref2$hasViewMode,
      _ref2$defaultMode = _ref2.defaultMode,
      defaultMode = _ref2$defaultMode === void 0 ? 'list' : _ref2$defaultMode,
      _ref2$hasTotal = _ref2.hasTotal,
      hasTotal = _ref2$hasTotal === void 0 ? true : _ref2$hasTotal,
      _ref2$rowText = _ref2.rowText,
      rowText = _ref2$rowText === void 0 ? 'row' : _ref2$rowText,
      _ref2$showPerPageText = _ref2.showPerPageText,
      showPerPageText = _ref2$showPerPageText === void 0 ? 'Show per page' : _ref2$showPerPageText,
      _ref2$pageText = _ref2.pageText,
      pageText = _ref2$pageText === void 0 ? 'Page' : _ref2$pageText,
      _ref2$rowsText = _ref2.rowsText,
      rowsText = _ref2$rowsText === void 0 ? 'rows' : _ref2$rowsText,
      _ref2$searchText = _ref2.searchText,
      searchText = _ref2$searchText === void 0 ? 'Search' : _ref2$searchText,
      _ref2$filteredText = _ref2.filteredText,
      filteredText = _ref2$filteredText === void 0 ? 'filtered' : _ref2$filteredText,
      _ref2$filters = _ref2.filters,
      filters = _ref2$filters === void 0 ? [] : _ref2$filters,
      _ref2$gridColumns = _ref2.gridColumns,
      gridColumns = _ref2$gridColumns === void 0 ? 3 : _ref2$gridColumns,
      _ref2$delay = _ref2.delay,
      delay = _ref2$delay === void 0 ? 500 : _ref2$delay,
      onSearchChange = _ref2.onSearchChange,
      onFilterChange = _ref2.onFilterChange,
      controlledFilter = _ref2.filter,
      controlledSearch = _ref2.search,
      _ref2$loadingText = _ref2.loadingText,
      loadingText = _ref2$loadingText === void 0 ? 'Loading' : _ref2$loadingText,
      _ref2$clearFiltersTex = _ref2.clearFiltersText,
      clearFiltersText = _ref2$clearFiltersTex === void 0 ? 'Clear filters' : _ref2$clearFiltersTex,
      _ref2$ofText = _ref2.ofText,
      ofText = _ref2$ofText === void 0 ? 'of' : _ref2$ofText,
      _ref2$noResultsText = _ref2.noResultsText,
      noResultsText = _ref2$noResultsText === void 0 ? {
    title: 'No results found',
    description: 'Try adjusting your search or filter to find what you are looking for.'
  } : _ref2$noResultsText,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var _useState = useState(controlledPageIndex),
      _useState2 = _slicedToArray(_useState, 2),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = useState(defaultPageSize),
      _useState4 = _slicedToArray(_useState3, 2),
      pageSize = _useState4[0],
      setPageSize = _useState4[1];

  var _useState5 = useState(defaultMode),
      _useState6 = _slicedToArray(_useState5, 2),
      view = _useState6[0],
      setView = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      searchTerm = _useState8[0],
      setSearchTerm = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      searchResults = _useState10[0],
      setSearchResults = _useState10[1];

  var _useReducer = useReducer(reducer, {}),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      query = _useReducer2[0],
      dispatch = _useReducer2[1];

  var total = controlledTotal || items.length;

  var _DATA = usePagination(searchResults, pageSize);

  var _useDebounce = useDebounce(function () {
    onSearchChange && onSearchChange(searchTerm.trim());

    if (hasPagination) {
      _DATA.jump(1);

      setPage(1);
    }

    dispatch({
      type: 'search',
      payload: {
        key: searchBy,
        value: searchTerm.trim()
      }
    });
  }, delay, [searchTerm]),
      _useDebounce2 = _slicedToArray(_useDebounce, 2),
      cancel = _useDebounce2[1];

  useEffect(function () {
    function resetView() {
      _DATA.jump(1);
    }

    if (searchTerm === null && searchResults.length > 0) {
      resetView();
    }
  }, [searchResults, searchTerm]);
  useEffect(function () {
    if (onFilterChange) {
      controlledFilter && controlledFilter.map(function (filter) {
        return dispatch({
          type: 'search',
          payload: {
            key: filter.key,
            value: filter.value
          }
        });
      });
    }
  }, [onFilterChange, controlledFilter]);
  useEffect(function () {
    if (onSearchChange) {
      setSearchTerm(controlledSearch.trim());
      dispatch({
        type: 'search',
        payload: {
          key: searchBy,
          value: controlledSearch.trim()
        }
      });
    }
  }, [onSearchChange, searchBy, controlledSearch]);
  var results = useMemo(function () {
    return filterPlainArray(items, query);
  }, [items, query]);
  useEffect(function () {
    if (searchTerm === null) {
      setSearchResults(items);
    } else {
      setSearchResults(results);
    }
  }, [results, items, searchTerm]);
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-list"), true), _defineProperty(_cx, "".concat(prefix, "-list--hideSearch"), !isSearchable), _defineProperty(_cx, "".concat(prefix, "-list--hideTotal"), !hasTotal), _defineProperty(_cx, customClassName, !!customClassName), _cx));

  var ListLoading = _jsx(Styled.ListBody, {
    children: _jsx(Loading, {
      children: loadingText
    })
  });

  var controlledList = _jsxs(Styled.List, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsxs(Styled.ListHead, {
      children: [_jsx(Styled.ListHeadCell, {
        children: hasTotal && _jsxs(_Fragment, {
          children: [controlledFilteredTotal ? controlledFilteredTotal : total, ' ', rowsText]
        })
      }), _jsxs(Styled.ListHeadCell, {
        right: true,
        children: [isSearchable && _jsx(Styled.ListSearch, {
          placeholder: searchText,
          value: searchTerm,
          onChange: function onChange(_ref3) {
            var currentTarget = _ref3.currentTarget;
            setSearchTerm(currentTarget.value);

            if (!currentTarget.value) {
              dispatch({
                type: 'clear_search',
                payload: {
                  key: searchBy
                }
              });
              cancel();
              onSearchChange && onSearchChange('');
              hasPagination && setPage(1);
            }
          }
        }), filters.map(function (filterItem, i) {
          return _jsx(Styled.ListControl, {
            children: _jsx(Dropdown, {
              label: filterItem.label,
              placeholder: filterItem.defaultText,
              value: String(query[filterItem.key]),
              onChange: function onChange(e) {
                dispatch({
                  type: 'search',
                  payload: {
                    key: filterItem.key,
                    value: e.target.value
                  }
                });

                if (onFilterChange) {
                  var updatedData = controlledFilter.map(function (x) {
                    return x.key === filterItem.key ? _objectSpread(_objectSpread({}, x), {}, {
                      key: filterItem.key,
                      value: e.target.value
                    }) : x;
                  });
                  onFilterChange(updatedData);
                }
              },
              children: _jsx(OptionsList, {
                options: filterItem.options
              })
            })
          }, i);
        }), (isSearchable || filters.length > 0) && hasViewMode && _jsx(Divider, {
          orientation: "vertical",
          isFlexChild: true,
          style: {
            marginTop: 4,
            marginBottom: 4
          }
        }), hasViewMode && _jsxs(SegmentedControl, {
          isIconOnly: true,
          onChange: function onChange(e) {
            return setView(e.target.value);
          },
          value: view,
          children: [_jsx(SegmentedControl.Button, {
            value: "grid",
            icon: "layout-grid",
            children: "Grid"
          }), _jsx(SegmentedControl.Button, {
            value: "list",
            icon: "properties",
            children: "List"
          })]
        }), (isSearchable || filters.length > 0) && action && _jsx(Divider, {
          orientation: "vertical",
          isFlexChild: true,
          style: {
            marginTop: 4,
            marginBottom: 4,
            marginRight: 0
          }
        }), action && _jsx(Styled.ListAction, {
          className: "".concat(prefix, "-list-action"),
          children: _jsx(Button, {
            iconLeft: action.icon,
            variant: "tertiary",
            onClick: action.onClick,
            onBlur: action.onBlur,
            isDisabled: action.isDisabled,
            isLoading: action.isLoading,
            children: action.content
          })
        })]
      })]
    }), isLoading ? ListLoading : _jsx(Styled.ListBody, {
      children: total === 0 ? emptyState && emptyState : isEmpty ? _jsx(EmptyState, {
        layout: "vertical",
        size: "small",
        image: null,
        title: noResultsText.title,
        children: noResultsText.description && _jsx(Paragraph, {
          children: noResultsText.description
        })
      }) : view === 'grid' ? _jsx(Card.Group, {
        cols: gridColumns,
        spacing: 16,
        children: items.map(function (item, i) {
          return renderItem(item, i, view);
        })
      }) : items.map(function (item, i) {
        return renderItem(item, i, view);
      })
    })]
  }));

  var uncontrolledList = _jsxs(Styled.List, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsxs(Styled.ListHead, {
      children: [_jsx(Styled.ListHeadCell, {
        children: hasTotal && _jsxs(_Fragment, {
          children: [searchResults.length, ' ', searchResults.length <= 1 ? rowText : rowsText, ' ', searchResults.length < total && _jsxs(_Fragment, {
            children: [_jsx("span", {
              className: "filtered",
              children: filteredText
            }), _jsx(Link, {
              style: {
                marginLeft: 8
              },
              onClick: function onClick() {
                setSearchTerm('');
                dispatch({
                  type: 'clear'
                });
                onSearchChange && onSearchChange('');
                onFilterChange && onFilterChange([]);
                hasPagination && setPage(1);
              },
              children: clearFiltersText
            })]
          })]
        })
      }), _jsxs(Styled.ListHeadCell, {
        right: true,
        children: [isSearchable && _jsx(Styled.ListSearch, {
          placeholder: searchText,
          value: searchTerm,
          onChange: function onChange(_ref4) {
            var currentTarget = _ref4.currentTarget;
            setSearchTerm(currentTarget.value);

            if (!currentTarget.value) {
              dispatch({
                type: 'clear_search',
                payload: {
                  key: searchBy
                }
              });
              cancel();
              onSearchChange && onSearchChange('');
              hasPagination && setPage(1);
            }
          }
        }), filters.map(function (filterItem, i) {
          return _jsx(Styled.ListControl, {
            children: _jsx(Dropdown, {
              label: filterItem.label,
              placeholder: filterItem.defaultText,
              value: String(query[filterItem.key]),
              onChange: function onChange(e) {
                dispatch({
                  type: 'search',
                  payload: {
                    key: filterItem.key,
                    value: e.target.value
                  }
                });

                if (onFilterChange) {
                  var updatedData = controlledFilter.map(function (x) {
                    return x.key === filterItem.key ? _objectSpread(_objectSpread({}, x), {}, {
                      key: filterItem.key,
                      value: e.target.value
                    }) : x;
                  });
                  onFilterChange(updatedData);
                }
              },
              children: _jsx(OptionsList, {
                options: filterItem.options
              })
            })
          }, i);
        }), (isSearchable || filters.length > 0) && hasViewMode && _jsx(Divider, {
          orientation: "vertical",
          isFlexChild: true,
          style: {
            marginTop: 4,
            marginBottom: 4
          }
        }), hasViewMode && _jsxs(SegmentedControl, {
          isIconOnly: true,
          onChange: function onChange(e) {
            return setView(e.target.value);
          },
          value: view,
          children: [_jsx(SegmentedControl.Button, {
            value: "grid",
            icon: "layout-grid",
            children: "Grid"
          }), _jsx(SegmentedControl.Button, {
            value: "list",
            icon: "properties",
            children: "List"
          })]
        }), (isSearchable || filters.length > 0) && action && _jsx(Divider, {
          orientation: "vertical",
          isFlexChild: true,
          style: {
            marginTop: 4,
            marginBottom: 4,
            marginRight: 0
          }
        }), action && _jsx(Styled.ListAction, {
          className: "".concat(prefix, "-list-action"),
          children: _jsx(Button, {
            iconLeft: action.icon,
            variant: "tertiary",
            onClick: action.onClick,
            onBlur: action.onBlur,
            isDisabled: action.isDisabled,
            isLoading: action.isLoading,
            children: action.content
          })
        })]
      })]
    }), isLoading ? ListLoading : _jsx(Styled.ListBody, {
      children: total === 0 ? emptyState && emptyState : searchResults.length === 0 ? _jsx(EmptyState, {
        layout: "vertical",
        size: "small",
        image: null,
        title: noResultsText.title,
        children: noResultsText.description && _jsx(Paragraph, {
          children: noResultsText.description
        })
      }) : view === 'grid' ? _jsx(Card.Group, {
        cols: gridColumns,
        spacing: 16,
        children: hasPagination ? _DATA.currentData().map(function (item, i) {
          return renderItem(item, i, view);
        }) : searchResults.map(function (item, i) {
          return renderItem(item, i, view);
        })
      }) : hasPagination ? _DATA.currentData().map(function (item, i) {
        return renderItem(item, i, view);
      }) : searchResults.map(function (item, i) {
        return renderItem(item, i, view);
      })
    }), hasPagination && !isLoading && _jsxs(Styled.ListPagination, {
      children: [_jsx(Styled.ListPaginationOptions, {
        children: _jsx(Stack, {
          alignItems: "center",
          children: _jsxs(Styled.ListPaginationSelection, {
            children: [showPerPageText, ":", _jsx(Dropdown, {
              style: {
                marginLeft: 8,
                marginRight: 8
              },
              value: pageSize,
              isDisabled: searchResults.length === 0,
              onChange: function onChange(e) {
                _DATA.jump(1);

                setPage(1);
                setPageSize(Number(e.target.value));
              },
              children: pageSizeOptions.map(function (pageSize) {
                return _jsx(Dropdown.Option, {
                  value: pageSize,
                  children: pageSize
                }, pageSize);
              })
            })]
          })
        })
      }), _jsx(Styled.ListPaginationNavigation, {
        children: _jsxs(Stack, {
          alignItems: "center",
          children: [pageText, _jsx(Dropdown, {
            style: {
              marginLeft: 8,
              marginRight: 8
            },
            value: page,
            isDisabled: _DATA.maxPage <= 1,
            onChange: function onChange(e) {
              _DATA.jump(Number(e.target.value));

              setPage(Number(e.target.value));
            },
            children: Array.from({
              length: _DATA.maxPage
            }, function (_, index) {
              return _jsx(Dropdown.Option, {
                value: index + 1,
                children: index + 1
              }, index);
            })
          }), ofText, " ", _DATA.maxPage <= 1 ? 1 : _DATA.maxPage, _jsxs(Styled.ListPaginationButtons, {
            children: [_jsx(IconButton, {
              icon: "arrow-left",
              variant: "ghost",
              size: "small",
              isDisabled: _DATA.currentPage <= 1,
              onClick: function onClick() {
                _DATA.prev();

                setPage(_DATA.currentPage - 1);
              }
            }), _jsx(IconButton, {
              icon: "arrow-right",
              variant: "ghost",
              size: "small",
              isDisabled: _DATA.currentPage === _DATA.maxPage || _DATA.maxPage <= 1,
              onClick: function onClick() {
                _DATA.next();

                setPage(_DATA.currentPage + 1);
              }
            })]
          })]
        })
      })]
    })]
  }));

  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: isManualPagination ? controlledList : uncontrolledList
  });
});
var ListRow = forwardRef(function (_ref5, ref) {
  var _cx2;

  var customClassName = _ref5.className,
      title = _ref5.title,
      metadata = _ref5.metadata,
      media = _ref5.media,
      children = _ref5.children,
      actions = _ref5.actions,
      onClick = _ref5.onClick,
      rest = _objectWithoutProperties(_ref5, _excluded2);

  var className = cx((_cx2 = {}, _defineProperty(_cx2, "".concat(prefix, "-structured-list-row"), true), _defineProperty(_cx2, customClassName, !!customClassName), _cx2));
  return _jsxs(Styled.ListRow, _objectSpread(_objectSpread({
    onClick: onClick,
    className: className
  }, rest), {}, {
    children: [media && _jsx(Styled.ListCell, {
      image: true,
      children: media
    }), _jsxs(Styled.ListCell, {
      children: [_jsx(Styled.ListTitle, {
        children: title
      }), metadata && _jsx(Styled.ListCaption, {
        children: metadata
      })]
    }), children && _jsx(Styled.ListCell, {
      children: children
    }), _jsx(Styled.ListCell, {
      actions: true,
      children: onClick ? _jsx(Icon, {
        icon: "chevron-right",
        color: 'var(--dentsu-color-blue)'
      }) : actions
    })]
  }));
});
List.Row = ListRow;
List.Card = Card;
List.displayName = 'List';
export default List;